import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "recycle",
  "use": "recycle-usage",
  "viewBox": "0 0 18.18 20",
  "content": "<symbol viewBox=\"0 0 18.18 20\" id=\"recycle\"><title>recycle</title><path d=\"M6.36,16.25A.62.62,0,0,0,7,15.63V8.75a.61.61,0,1,0-1.21,0v6.87A.61.61,0,0,0,6.36,16.25Zm3.64,0a.62.62,0,0,0,.61-.62V8.75a.61.61,0,1,0-1.21,0v6.87A.61.61,0,0,0,10,16.25Zm3.64,0a.62.62,0,0,0,.61-.62V8.75a.61.61,0,1,0-1.21,0v6.87A.62.62,0,0,0,13.64,16.25Zm3-14.37H14.16A2.44,2.44,0,0,0,11.82,0H8.18A2.44,2.44,0,0,0,5.84,1.88H3.33A2.47,2.47,0,0,0,.91,4.38V5h.61v.62H2.73V17.5A2.47,2.47,0,0,0,5.15,20h9.7a2.47,2.47,0,0,0,2.42-2.5V5.63h1.21V5h.61V4.38A2.47,2.47,0,0,0,16.67,1.88ZM8.18,1.25h3.64a1.2,1.2,0,0,1,1,.62H7.14A1.2,1.2,0,0,1,8.18,1.25ZM16.06,17.5a1.23,1.23,0,0,1-1.21,1.25H5.15A1.3,1.3,0,0,1,3.86,17.5L3.94,5.63H16.06ZM2.12,4.38A1.23,1.23,0,0,1,3.33,3.13H16.67a1.23,1.23,0,0,1,1.21,1.25Z\" transform=\"translate(-0.91)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/recycle.svg
// module id = palW
// module chunks = 264